import { useEffect } from "react";
import { useRouter } from "next/router";
import { useUserContext } from "../context/auth/user.context";

const useRequireCompleteProfile = () => {
  const { user, isLoading, isAuthenticated } = useUserContext();
  const router = useRouter();

  useEffect(() => {
    if (
      !isLoading &&
      isAuthenticated &&
      user &&
      !user.profileComplete &&
      user.hasSocialAccount &&
      router.pathname !== "/complete-profile"
    ) {
      router.replace("/complete-profile");
    }
  }, [user, isLoading, isAuthenticated, router]);
};

export default useRequireCompleteProfile;
